import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_umczc7bspa: FaireBrandEntity = {
  token: "b_umczc7bspa",
  type: "brand",
  name: "Queens Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/eb73f5f666d8712de24f64dd530d13d8eabb7d8949997a8132b52ee5c02f1731.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d58e9d51c6438121e60914c1db39b37c0b05a987125b55556bb092c4738b4e03.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/eb73f5f666d8712de24f64dd530d13d8eabb7d8949997a8132b52ee5c02f1731.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d58e9d51c6438121e60914c1db39b37c0b05a987125b55556bb092c4738b4e03.jpeg",
  location: "Atlanta, GA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 59,
  isTopShop: true,
  isInsider: true,
  description:
    "Family-owned and operated since 2004, Queens Designs, a leader in the fashion accessories industry was established in Atlanta GA. Initially, we started off as leaders in the fashion watch industry, carrying all kinds of fashion watches imaginable for women, men, and children. In the last 8 years, we have transitioned to the fashion accessories category, including but not limited to women’s clothing and apparel, accessories, bags, jewelry, sunglasses, and so much more. As designers, manufacturers, importers, and wholesalers, our mission is to identify the most current fashion trends and provide outstanding quality merchandise at competitive prices while extending exceptional customer service to our retailers and wholesalers.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:34.193Z",
    importedBy: "entity-db-cli",
  },
};
